var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tabs',{attrs:{"fixed-tabs":"","background-color":"rgb(192, 215, 228)","color":"#1d3557","max-width":"none","width":"25px"},model:{value:(_vm.activeTab),callback:function ($$v) {_vm.activeTab=$$v},expression:"activeTab"}},[_c('v-tab',[_vm._v(" Population equality? ")]),_c('v-tab',[_vm._v(" Demographics ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }